function g(o) {
  const e = new BroadcastChannel(o);
  function c(s = "any", a = (n) => {
  }) {
    e.onmessage = (n) => {
      const t = JSON.parse(n.data);
      t.type === s && a(t.message);
    };
  }
  function r(s = "any", a = "any") {
    e.postMessage(JSON.stringify({ type: s, message: a }));
  }
  return {
    onMessage: c,
    postMessage: r
  };
}
export {
  g as default,
  g as useBroadcastTabChannel
};
